/** sky-x new: menu and chat are mutually exclusive (Header ↔ ChatWidget). */
export const SKYX_NEW_CLOSE_MENU = 'skyx_new:close-menu';
export const SKYX_NEW_CLOSE_CHAT = 'skyx_new:close-chat';
/** Player avatar selection changed (menu, change-avatar modal, CDN pool). */
export const SKYX_NEW_PLAYER_AVATAR_CHANGED = 'skyx_new:player-avatar-changed';
